import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3 21h18"
    }, null, -1),
    _createElementVNode("rect", {
      width: "3.6",
      height: "14.4",
      x: "3.9",
      y: "3",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "3.6",
      height: "12.6",
      x: "16.5",
      y: "4.8",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "3.6",
      height: "7.2",
      x: "10.2",
      y: "10.2",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      rx: "1"
    }, null, -1)
  ]))]))
}
export default { render: render }